module.exports = __webpack_public_path__ + "img/media.efd5126d.png";